import { register } from 'swiper/element/bundle';
const swiperRegister = () => register();
export { swiperRegister };
